import React, { useState } from "react";
import "./TopFiveMostPopSeries.scss";
import "./TopFiveMostPopSeriesMobile.scss";
import { useNavigate } from "react-router-dom";
import triple from "../../Assets/manga-tripple-quote.png";
import seemoreArrow from "../../Assets/Seemore-arrow.png";
import seemoreInverted from "../../Assets/Seemore-inverted.png";
import AnimeSeriesCard from "../Utilities/AnimeSeriesCard";

function TopFiveMostPopSeries({ data, titleName, id }) {
  const [seemoreHover, setSeemoreHover] = useState(false);
  const imagePath = "Assets/AnimeFigures";
  const navigate = useNavigate();

  return (
    <div class="topFiveMostPopSeries" id={id}>
      <div className="mps-title">
        <div className="mps-title-container">
          <div className="mps-title-wrapper-black">
            <div className="mps-title-wrapper-white-dashed">
              <p>{titleName}</p>
            </div>
            <img className="tripleQoute" src={triple}></img>
            <img className="tripleQoute2" src={triple}></img>
          </div>
        </div>
      </div>{" "}
      <div className="mps-content">
        <AnimeSeriesCard animeSeriesData={data} />
        <button
          className="btn-seemore"
          onClick={() => {
            localStorage.setItem(
              "redirectAfterLogin",
              JSON.stringify({
                path: window.location.pathname,
                scrollTop: 0,
              })
            );
            navigate(`/products`);
          }}
        >
          S E E M O R E
        </button>
        <div
          className="mps-seemore"
          onMouseEnter={() => setSeemoreHover(true)}
          onMouseLeave={() => setSeemoreHover(false)}
          onClick={() => {
            localStorage.setItem(
              "redirectAfterLogin",
              JSON.stringify({
                path: window.location.pathname,
                scrollTop: 0,
              })
            );
            navigate(`/products`);
          }}
        >
          <p>
            &nbsp;S
            <br />
            &nbsp;E
            <br />
            &nbsp;E
            <br />
            <br />
            &nbsp;M
            <br />
            &nbsp;O
            <br />
            &nbsp;R
            <br />
            &nbsp;E
          </p>

          {/* Stacked images for circular reveal */}
          <img
            className="seemore-img seemore-img-base"
            src={seemoreArrow}
            alt="See more arrow"
            draggable="false"
            style={{ pointerEvents: "none" }}
          />
          <img
            className="seemore-img seemore-img-inverted"
            src={seemoreInverted}
            alt="See more arrow inverted"
            draggable="false"
            style={{ pointerEvents: "none" }}
          />
        </div>
      </div>
    </div>
  );
}

export default TopFiveMostPopSeries;
